(function () {
  if (customElements.get('internal-video')) return;

  class InternalVideo extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      if (!this.video) return;

      this._sourcesLoaded = false;

      this.playBtn = this.querySelector('.internal-video__play');
      this.soundBtn = this.querySelector('.internal-video__sound-btn');
      this.fullscreenBtn = this.querySelector('.internal-video__fullscreen-btn');
      this.timeline = this.querySelector('.internal-video__timeline');

      if (this.playBtn) {
        this.playBtn.addEventListener('click', () => this.togglePlay());
      }
      if (this.soundBtn) {
        this.soundBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          this.toggleSound();
        });
      }
      if (this.fullscreenBtn) {
        this.fullscreenBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          this.toggleFullscreen();
        });
      }
      if (this.timeline) {
        this.video.addEventListener('timeupdate', () => this._updateTimeline());
      }

      // Lazy: only load + observe once the slide is actually near the viewport
      this._setupLazyObserver();
    }

    _setupLazyObserver() {
      if (!('IntersectionObserver' in window)) {
        // Fallback: no lazy loading support, load right away
        this._loadSources();
        if (this.dataset.autoplay === 'true') this._play();
        return;
      }
      this._observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              if (!this._sourcesLoaded) this._loadSources();
              if (this.dataset.autoplay === 'true') this._play();
            } else if (this._sourcesLoaded) {
              this._handleInactive();
            }
          });
        },
        { threshold: 0.25, rootMargin: '200px 0px' } // starts loading a bit before it's fully in view
      );
      this._observer.observe(this);
    }

    _loadSources() {
      const sources = this.video.querySelectorAll('source[data-src]');
      sources.forEach((source) => {
        source.src = source.getAttribute('data-src');
        source.removeAttribute('data-src');
      });
      this.video.load();
      this._sourcesLoaded = true;
    }

    _handleInactive() {
      const action = this.dataset.actionOnInactive;
      if (action === 'pause') this._pause();
      else if (action === 'mute') this.video.muted = true;
    }

    _play() {
      this.video.play().catch(() => {});
      this.classList.add('internal-video--playing');
    }

    _pause() {
      this.video.pause();
      this.classList.remove('internal-video--playing');
    }

    togglePlay() {
      if (!this._sourcesLoaded) this._loadSources();
      if (this.video.paused) this._play();
      else this._pause();
    }

    toggleSound() {
      this.video.muted = !this.video.muted;
      this.classList.toggle('internal-video--muted', this.video.muted);
    }

    toggleFullscreen() {
      if (this.video.requestFullscreen) this.video.requestFullscreen();
      else if (this.video.webkitRequestFullscreen) this.video.webkitRequestFullscreen();
    }

    _updateTimeline() {
      if (!this.video.duration || !this.timeline) return;
      const pct = (this.video.currentTime / this.video.duration) * 100;
      this.timeline.style.setProperty('--progress', pct + '%');
    }
  }

  customElements.define('internal-video', InternalVideo);
})();